import type { HttpService } from '../../../App/services/http-service';
import type { ConfigService } from '../../../App/services/mx-config-service';

export class FeedbackProviderService {
	public isFeedbackVisible = false;
	public FeedbackEnabled = false;

	static $inject = ['mx.shell.Http', 'mx.shell.Config'];
	constructor(private readonly http: HttpService, private readonly config: ConfigService) {}

	public async send(feedback: string): Promise<void> {
		await this.http.post('api/feedback/Send', feedback);
	}

	public getContext(): string {
		return 'context comment';
	}

	public async isEnabled(): Promise<boolean> {
		const cfg = this.config.get('toolbar') || {};
		if (cfg.showFeedback) {
			const data = await this.http.get('api/feedback/Enabled');
			return Boolean(data);
		}
		return false;
	}
}
